export default {
  getMethods: (state) => state.methods,
  getMethodById: (state) => (id) => state.methods.find(method => method._id === id),
  isLoading: (state) => state.loading,
  getError: (state) => state.error,
};
